(function() {
  'use strict';

  angular.module('ringbaPortal').directive('trCampaignSection', trCampaignSection);

  function trCampaignSection() {
    const directive = {
      restrict: 'E',
      transclude: {
        'headerExtra': '?headerExtra',
        'titleExtra': '?titleExtra'
      },
      scope: {
        widgetTitle: '@',
        settings: '&',
        showPanel: '&',
        headerCollapse: '&',
        onHeaderClick: '&',
        widgetHolderClass: '@',
        widgetTitleCustomClass: '@'
      },
      templateUrl: '/scripts/shared/directives/campaign-sections/campaign-sections.view.html',
      compile: compile
    };

    return directive;

    function compile () {
      return {
        post: function (scope) {
          scope._handleHeaderClick = function (event) {
            if (typeof scope.onHeaderClick === 'function' && event.currentTarget.className === 'campaign-section__header_content') {
              scope.onHeaderClick({$event:event});
            }
          };
        }
      };
    }


  }
})();
